import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Import error boundary
import PageErrorBoundary from './components/PageErrorBoundary';

// Import page components
import HomePage from './pages/index';
import ServicesPage from './pages/services';
import ServicePackagesPage from './pages/service-packages';
import PortfolioPage from './pages/portfolio';
import AboutPage from './pages/about';
import FAQPage from './pages/faq';
import ContactPage from './pages/contact';
import NotFound from './pages/NotFound';

// Import admin pages
import AdminDashboard from './pages/admin/index';
import AdminClients from './pages/admin/clients';
import AdminClientEmails from './pages/admin/client-emails';
import AdminProjects from './pages/admin/projects';
import AdminAssets from './pages/admin/assets';
import AdminAuditLogs from './pages/admin/audit-logs';
import ProtectedRoute from './components/ProtectedRoute';

// Import client portal pages
import ClientPortal from './pages/client/ClientPortal';
import ProjectDetails from './pages/client/ProjectDetails';

/**
 * Main App component with routing
 * @returns {React.ReactElement} App component
 */
function App() {
  return (
    <PageErrorBoundary>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/service-packages" element={<ServicePackagesPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/contact" element={<ContactPage />} />
          
          {/* Admin Routes - Protected by Cloudflare Access */}
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/clients" element={<ProtectedRoute><AdminClients /></ProtectedRoute>} />
          <Route path="/admin/client-emails" element={<ProtectedRoute><AdminClientEmails /></ProtectedRoute>} />
          <Route path="/admin/projects" element={<ProtectedRoute><AdminProjects /></ProtectedRoute>} />
          <Route path="/admin/assets" element={<ProtectedRoute><AdminAssets /></ProtectedRoute>} />
          <Route path="/admin/audit-logs" element={<ProtectedRoute><AdminAuditLogs /></ProtectedRoute>} />
          
          {/* Client Portal Routes */}
          <Route path="/client" element={<ClientPortal />} />
          <Route path="/client/projects/:projectId" element={<ProjectDetails />} />
          
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </PageErrorBoundary>
  );
}

export default App;
